import {HttpClient,HttpEvent,HttpRequest,HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {SERVER_API_URL} from 'src/app/app.constants';
import {IPolicyMySuffix} from 'src/app/shared/model/policy-my-suffix.model';
import {IScopeMySuffix} from 'src/app/shared/model/scope-my-suffix.model';
import {StroageInsuranceFilterPagination} from 'src/app/shared/model/storage-insurance-filter-pagination.model';
import {createRequestOption} from 'src/app/shared/util/request-util';
import {PolicyRenewDto,PolicyRenewalMySuffix} from './policy-renewal.model';


type EntityResponseType = HttpResponse<IPolicyMySuffix>;
type EntityArrayResponseType = HttpResponse<IPolicyMySuffix[]>;
type EntityResponseTypePolicyRenew = HttpResponse<PolicyRenewalMySuffix>;

@Injectable({ providedIn: 'root' })
export class PolicyMySuffixService {
    private resourceUrl = SERVER_API_URL + 'api/policies';
    private resourceUrlPolicies = SERVER_API_URL + 'api/policies/basicInfo';
    private resourceUrlForScopeEdit = SERVER_API_URL + 'api/policies/scopeEdit';
    private resourceSaveUrl = SERVER_API_URL + 'api/save/scopes';
    private brokerUserData = SERVER_API_URL + 'api/broker/internal-staffs';
    private openPolicyUrl = SERVER_API_URL + 'api/open-policies';
    private getPolicyData = SERVER_API_URL + "api/policy/renew/"
    private storageLocationUrl = SERVER_API_URL + 'api/policy-storage-loaction';
    private policyRenewScopeView = SERVER_API_URL + "api/scopes/renew/view/";
    private policyRenewUpdate = SERVER_API_URL + "api/policy/renew";
    private policyCancelUrl=SERVER_API_URL+ 'api/policy/cancel'; 
    private policyMyLossPayee=SERVER_API_URL+"api/loss-payee-policy-client-id/";
    private overagePremiumScheduleUrl = SERVER_API_URL + "api/insurance-product-overage";
    private policysaveAsDraft = SERVER_API_URL + 'api/policies/save-as-draft';
    private resourceUrlOpenPolicies = SERVER_API_URL + 'api/mypolicy/basicInfo';
    private countriesByContinents  = SERVER_API_URL +'api/users/get-country-cont-reg';

    constructor(private http: HttpClient) { }
    // /policy-loading-types/all

    create(policy: IPolicyMySuffix): Observable<EntityResponseType> {
        const copy = this.convertDateFromClient(policy);
        return this.http
            .post<IPolicyMySuffix>(this.resourceUrl, copy, { observe: 'response' })
            .map((res: EntityResponseType) => this.convertDateFromServer(res));
    }

    update(policy: IPolicyMySuffix): Observable<EntityResponseType> {
        const copy = this.convertDateFromClient(policy);
        return this.http

            .put<IPolicyMySuffix>(this.resourceUrl, copy, { observe: 'response' })
            .map((res: EntityResponseType) => this.convertDateFromServer(res));
    }

    policyRenew(policy: PolicyRenewalMySuffix): Observable<EntityResponseTypePolicyRenew> {
        const copy = this.convertDateFromClientPolicyRenew(policy);
        return this.http

            .put<PolicyRenewalMySuffix>(this.policyRenewUpdate, copy, { observe: 'response' })
            .map((res: EntityResponseTypePolicyRenew) => res);
    }
    policyCancel(policy: PolicyRenewalMySuffix): Observable<EntityResponseTypePolicyRenew> {
        // const copy = this.convertDateFromClientPolicyRenew(policy);
        return this.http

            .put<PolicyRenewalMySuffix>(this.policyCancelUrl, policy, { observe: 'response' })
            .map((res: EntityResponseTypePolicyRenew) => res);
    }


    find(id: number): Observable<EntityResponseType> {
        return this.http
            .get<IPolicyMySuffix>(`${this.resourceUrl}/${id}`, { observe: 'response' })
            .map((res: EntityResponseType) => this.convertDateFromServer(res));
    }

    view(id: number): Observable<EntityResponseType> {
        return this.http
            .get<IPolicyMySuffix>(`${this.resourceUrl}/view/${id}`, { observe: 'response' })
            .map((res: EntityResponseType) => this.convertDateFromServer(res));
    }

    findForOneTimeScopeEdit(id: number, certificateRequestId: number): Observable<EntityResponseType> {
        return this.http
            .get<IPolicyMySuffix>(`${this.resourceUrlForScopeEdit}/${id}/${certificateRequestId}`, { observe: 'response' })
            .map((res: EntityResponseType) => this.convertDateFromServer(res));
    }


    findForScopeEdit(id: number): Observable<EntityResponseType> {
        return this.http
            .get<IPolicyMySuffix>(`${this.resourceUrlForScopeEdit}/${id}`, { observe: 'response' })
            .map((res: EntityResponseType) => this.convertDateFromServer(res));
    }

    findRolesData(url?: any): Observable<any> {
        return this.http.get<any>(SERVER_API_URL + url, { observe: 'response' }).map((res: EntityResponseType) => res);
    }
    findProjectManagerData(): Observable<any> {
        return this.http.get<any>(this.brokerUserData + '?manager=policy', { observe: 'response' }).map((res: EntityResponseType) => res);
    }
    findLossPayee(id?: any, type?: string): Observable<any> {
        return this.http
            .get<any>(this.policyMyLossPayee + id + "/" + type, { observe: 'response' })
            .map((res: any) => this.convertDateArrayFromServer(res));
    }
    query(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http
            .get<IPolicyMySuffix[]>(this.resourceUrl, { params: options, observe: 'response' })
            .map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res));
    }
    queryForPoliciesBasicInfo(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http
            .get<IPolicyMySuffix[]>(this.resourceUrlPolicies, { params: options, observe: 'response' })
            .map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res));
    }

    queryTest(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http
            .get(this.resourceUrl+'/myStorage', { params: options, observe: 'response' }) .map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res));

    }

    // myStorageInsuranceQuery(req?: any): Observable<HttpResponse<any[]>> {
    //     const options = createRequestOption(req);
    //     const URL =this.resourceUrl+'/myStorage';
    //     return this.http.get<any[]>(URL, { params: options, observe: 'response' });
    // }

    myStorageInsuranceQuery(req?: StroageInsuranceFilterPagination): Observable<any> {
        // const options = createRequestOption(req);
        const URL =this.resourceUrl+'/myStorage';
         return this.http.post<any[]>(URL, req, {  observe: 'response' });
     }
     myStorageInsuranceQuerySearch(req?: StroageInsuranceFilterPagination): Observable<any> {
        // const options = createRequestOption(req);
        const URL =this.resourceUrl+'/myStorage/search';
         return this.http.post<any[]>(URL, req, {  observe: 'response' });
     }
     queryBlobObject(url:string): Observable<HttpEvent<Blob>> {
        const _url = this.resourceUrl + url;
        return this.http.get(_url , { responseType: 'blob', observe: 'events' }).map(blob => {
            // window.open(_url);
            return blob;
        });
    }
  

    queryUnderWriterInsurers(policyId?:number): Observable<any> {
        let url =  policyId?'/'+policyId:'';
        const _url = SERVER_API_URL + 'api/policies/underWriterInsurers-insurance-companies'+url;
        return this.http.get<any[]>(_url, { observe: 'response' }).map((res: any) => res);
    }

    delete(id: number): Observable<HttpResponse<any>> {
        return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    
    deleteStoragePolicy(id: number): Observable<HttpResponse<any>> {
        const url = this.resourceUrl+'/storage-policy';
        return this.http.delete<any>(`${url}/${id}`, { observe: 'response' });
    }

    private convertDateFromClient(policy: IPolicyMySuffix): IPolicyMySuffix {
        const copy: IPolicyMySuffix = Object.assign({}, policy, {
            inceptionDate: policy.inceptionDate != null ? policy.inceptionDate.toJSON() : null,
            expiryDate: policy.expiryDate != null ? policy.expiryDate.toJSON() : null
        });
        return copy;
    }

    private convertDateFromClientPolicyRenew(policy: PolicyRenewalMySuffix): PolicyRenewalMySuffix {
        const copy: PolicyRenewalMySuffix = Object.assign({}, policy, {
            inceptionDate: policy.inceptionDateObj != null ? policy.inceptionDateObj.toJSON() : null,
            expiryDate: policy.expiryDateObj != null ? policy.expiryDateObj.toJSON() : null
        });
        return copy;
    }

    private convertDateFromServer(res: EntityResponseType): EntityResponseType {
        res.body.inceptionDate = res.body.inceptionDate != null ? new Date(res.body.inceptionDate) : null;
        res.body.expiryDate = res.body.expiryDate != null ? new Date(res.body.expiryDate) : null;
        return res;
    }

    private convertDateFromServerPolicyRenew(res: EntityResponseTypePolicyRenew): EntityResponseTypePolicyRenew {
        res.body.inceptionDateObj = res.body.inceptionDateObj != null ? new Date(res.body.inceptionDateObj) : null;
        res.body.expiryDateObj = res.body.expiryDateObj != null ? new Date(res.body.expiryDateObj) : null;
        return res;
    }

    saveAdminAPI(policy: IPolicyMySuffix): Observable<EntityResponseType> {
        const copy = this.convertDateFromClient(policy);
        return this.http
            .post<IPolicyMySuffix>(this.resourceSaveUrl, copy, { observe: 'response' })
            .map((res: EntityResponseType) => this.convertDateFromServer(res));
    }

    private convertDateArrayFromServer(res: EntityArrayResponseType): EntityArrayResponseType {
        res.body.forEach((policy: IPolicyMySuffix) => {
            policy.inceptionDate = policy.inceptionDate != null ? new Date(policy.inceptionDate) : null;
            policy.expiryDate = policy.expiryDate != null ? new Date(policy.expiryDate) : null;
        });
        return res;
    }

    saveFile(file: FormData, id: number): Observable<any> {
        return this.http.post<any>(SERVER_API_URL + 'api/upload/policyBook?id=' + id, file, { reportProgress: true, observe: 'response' });
    }
    downloadFile(id: number): Observable<Blob> {
        return this.http.get(SERVER_API_URL + 'api/download/policyBook?id=' + id, { responseType: 'blob' }).map(blob => {
            console.log('bloooob', blob);

            return blob;
        });
    }
    openQuery(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http
            .get<IPolicyMySuffix[]>(this.openPolicyUrl, { params: options, observe: 'response' })
            .map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res));
    }

    saveFilesecond(file: FormData, id: number): Observable<any> {
        const req = new HttpRequest('POST', SERVER_API_URL + 'api/upload/policyBook?id=' + id, file, {
            reportProgress: true,
            responseType: 'text'
        });
        return this.http.request(req);
    }
    downloadFilesecond(id: number): Observable<any> {
        const req = new HttpRequest('GET', SERVER_API_URL + 'api/download/policyBook?id=' + id, {
            reportProgress: true,
            responseType: 'blob'
        });
        return this.http.request(req);
    }


    findSumInsured(id: number): Observable<any> {
        return this.http
            .get<IPolicyMySuffix>(`${this.resourceUrl + '/sum-insured-details'}/${id}`, { observe: 'response' });
    }


    convertDateModel(selectedDate: any) {

        let day = ('0' + selectedDate.day).slice(-2);

        let month = ('0' + selectedDate.month).slice(-2);

        let year = selectedDate.year;

        return year + '-' + month + '-' + day;
    }

    downloadFileService(fileId: string): Observable<Blob> {
        const _url = SERVER_API_URL + 'api/file/get/' + fileId;
        return this.http.get(_url, { responseType: 'blob' }).map(blob => {
            // window.open(_url);
            return blob;
        });
    }

    findByIdAndFromEffectiveDate(id: number, fromEffectiveDate: string): Observable<EntityResponseType> {
        return this.http
            .get<IPolicyMySuffix>(`${this.resourceUrl}/${id}/${fromEffectiveDate}`, { observe: 'response' });
    }

    getPolicy(id: number): Observable<any> {
        const _url = this.getPolicyData + id;
        return this.http
            .get<PolicyRenewDto>(_url, { observe: 'response' });
    }
    queryAllStorageLocation(req?: any) {
        const options = createRequestOption(req);
        return this.http
            .get<any[]>(this.storageLocationUrl + '-all', { params: options, observe: 'response' });
    }
    queryStorageLocationById(id: number) {
        return this.http
            .get<any>(this.storageLocationUrl + '/' + id, { observe: 'response' })
    }

    saveStorageLocation(data: any) {
        return this.http
            .post<any>(this.storageLocationUrl, data, { observe: 'response' });
    }

    approveOrReject(id: number, status: string): Observable<HttpResponse<any>> {
        return this.http.delete<any>(`${this.storageLocationUrl + '-approve-reject'}/${id}/${status}`, { observe: 'response' });
    }

    ViewScopePlicyRenew(id: number): Observable<HttpResponse<any>> {
        return this.http
            .get<IScopeMySuffix>(this.policyRenewScopeView + id, { observe: 'response' })
            .map((res: HttpResponse<any>) => this.convertDateFromServer(res));
    }
    overagePremiumSchedule(policyNumber: number): Observable<any> {
        return this.http.get<any>(`${this.overagePremiumScheduleUrl}/${policyNumber}`, { observe: 'response' });
    }

    get(url?: any): Observable<any> {
        return this.http.get<any>(SERVER_API_URL + url, { observe: 'response' });
    }
    getByUrl(url?: any): Observable<any> {
        return this.http.get<any>(SERVER_API_URL  + url, { observe: 'response' });
    }


    getAllActiveunderwriter(): Observable<any>{
        return this.http.get<any>(SERVER_API_URL + 'api/underwriters-all/active', { observe: 'response' });
    }

    getSubscribingInsurers(policyId): Observable<any>{
        return this.http.get<any>(SERVER_API_URL + 'api/policies/get-subscribing-insurers/'+policyId, { observe: 'response' });
    }

    saveAsDraft(policy: IPolicyMySuffix): Observable<EntityResponseType>{
        const copy = this.convertDateFromClient(policy);
        return this.http
            .post<IPolicyMySuffix>(this.policysaveAsDraft, policy, { observe: 'response' })
            .map((res: EntityResponseType) => this.convertDateFromServer(res));

    }

    getSelectedPolicyHolderData(policyHolderId: number) {
        return this.http.get<any>(SERVER_API_URL + 'api/policies/policy-clients-by-Id/' + policyHolderId , { observe: 'response' });
    }

    getSpotPolicyHolderData() {
        return this.http.get<any>(SERVER_API_URL + 'api/spot-policies', { observe: 'response' });
    }
    
    queryForOpenPoliciesBasicInfo(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http
            .get<IPolicyMySuffix[]>(this.resourceUrlOpenPolicies, { params: options, observe: 'response' })
            .map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res));
    }

    getCoAssuredDetialsDuringDelete(policyHolderId: number,policyId:number) {
        return this.http.get<any>(SERVER_API_URL + 'api/policies/coassured/' + policyHolderId +'/'+ policyId, { observe: 'response' });
    }


    confirmCoAssurdDataDelete(data:any) {
        return this.http.post<any>(SERVER_API_URL + 'api/certificate-requests/favourite/unmarkall', data,{ observe: 'response' });
    }

    reScreenWarehouseStorage(data: any) {
        return this.http.post<any>(SERVER_API_URL + 'api/finscan/rescreen-entity', data, { observe: 'response' })
    }

    getCountriesByContinents() {
        return this.http.get<any>(this.countriesByContinents, {observe : 'response'});
    }

    getCountriesByContinentsByRuleId(id:number,type:string) {
        return this.http.get<any>(this.countriesByContinents+'/'+id+'/'+type, {observe : 'response'});
    }

    getAllSurveyCompanies(url) {
        return this.http.get<any>(SERVER_API_URL + url, { observe: 'response' });
    }
}